import {
  FormControl,
  FormControlLabel,
  Radio,
  RadioGroup,
  Stack,
  Typography,
} from "@mui/material";
import { ReuseModal } from "../../ReuseModal";
import { useState } from "react";
import { ExportAccountsOptions } from "../../../../types/enums";

type Props = {
  isOpen: boolean;
  onClose: () => void;
  onSubmit: (option: string) => void;
};

const options = ["CRM", "INFUSE"];
export const MissingDataSourceModal = ({
  isOpen,
  onClose,
  onSubmit,
}: Props) => {
  const [option, setOption] = useState<string>(options[0]);

  const submitHandler = () => {
    onSubmit(option);
    onClose();
  };

  return (
    <ReuseModal
      isOpen={isOpen}
      onClose={onClose}
      title={"Missing Data Source"}
      onSubmit={submitHandler}
      maxWidth="560px"
      submitBtnColor={"#1C3C6C"}
      submitBtnText={"Submit"}
    >
      <Stack gap="12px" paddingTop={"8px"}>
        <Typography
          component="span"
          variant="subtitle1"
          sx={{ color: "#4C545B" }}
        >
          We noticed your file(s) don't include a data source column. Please
          select where this data comes from.
        </Typography>
        <Typography
          component="span"
          variant="subtitle1"
          color="custom.textDarkBlue"
          fontWeight={500}
        >
          What is the data source for this file?
        </Typography>
        <FormControl sx={{ padding: 0, alignItems: "flex-start" }}>
          <RadioGroup
            aria-labelledby="demo-radio-buttons-group-label"
            defaultValue={option}
            value={option}
            name="radio-buttons-group"
            onChange={(e, el) => setOption(el as ExportAccountsOptions)}
          >
            {options.map((value) => (
              <FormControlLabel
                key={value}
                value={value}
                control={<Radio />}
                label={value}
                style={{ margin: 0 }}
              />
            ))}
          </RadioGroup>
        </FormControl>
      </Stack>
    </ReuseModal>
  );
};
